import {
  IApplyOrgUserMigrationResult,
  IOrgUserMigrationPreview,
  IOrgUserMigrationUser,
} from './orgUserMigrationApi'

export type OrgUserMigrationStep = 'loading' | 'review' | 'apply' | 'done'

export interface IOrgUserMigrationSummary {
  migrated: number
  alreadyAssigned: number
  skipped: number
}

export const toggleUserSelection = (
  selectedUserIds: Set<string>,
  userId: string,
  checked: boolean,
): Set<string> => {
  const next = new Set(selectedUserIds)
  checked ? next.add(userId) : next.delete(userId)
  return next
}

export const selectAllUsers = (
  candidates: IOrgUserMigrationUser[],
  selectAll: boolean,
): Set<string> => (selectAll ? new Set(candidates.map((user) => user.userId)) : new Set<string>())

export const buildApplyPayload = (
  candidates: IOrgUserMigrationUser[],
  selectedUserIds: Set<string>,
): string[] =>
  candidates.filter((user) => selectedUserIds.has(user.userId)).map((user) => user.userId)

export const summarizeResult = (
  result: IApplyOrgUserMigrationResult,
  candidateCount: number,
): IOrgUserMigrationSummary => ({
  migrated: result.migrated,
  alreadyAssigned: result.alreadyAssigned,
  skipped: Math.max(0, candidateCount - result.migrated - result.alreadyAssigned),
})

export const describeCompanies = (user: IOrgUserMigrationUser): string =>
  user.companies.length > 0 ? user.companies.map((company) => company.name).join(', ') : '—'

export const resolveInitialStep = (preview: IOrgUserMigrationPreview): OrgUserMigrationStep =>
  preview.candidates.length === 0 ? 'done' : 'review'

export const shouldShowOrgUserMigrationBanner = ({
  organizationId,
  canUseMultiProvDashboard,
  candidateCount,
}: {
  organizationId: number | undefined
  canUseMultiProvDashboard: boolean | undefined
  candidateCount: number
}): boolean => !!organizationId && canUseMultiProvDashboard === true && candidateCount > 0
